module.exports = __webpack_public_path__ + "img/map-block.fdb7911d.png";